export const log = (level = 'info', body) => {
  fetch(`${process.env.REACT_APP_LOGGING_API}/reporting/log/${level}`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
};
